<button class="user-button" mat-mini-fab [matMenuTriggerFor]="userMenu" aria-label="Open user menu" data-cy="header-user-menu-toggle">
  <mat-icon class="user-button__icon material-icons-outlined" aria-hidden="true">person</mat-icon>
</button>
<mat-menu #userMenu="matMenu" xPosition="before" aria-label="User options" data-cy="header-user-menu-panel">
  <div class="user-menu-title">
    <div class="user-menu-title__name">
      <ng-container *ngIf="currentEmployeeDetails?.preferredName; else showFirstName">{{currentEmployeeDetails?.preferredName}}</ng-container>
      <ng-template #showFirstName>{{currentEmployeeDetails?.firstname}}</ng-template> {{currentEmployeeDetails?.lastname}}
    </div>
    <a class="user-menu-title__link">{{currentEmployeeDetails?.username}}</a>
  </div>
  <button 
    mat-menu-item 
    *ngIf="currentEmployeeDetails.userType === 'Employee'" 
    class="user-menu__item-title" 
    data-cy="header-user-menu-profile"
    routerLink="{{routes.TALENT_TRACK}}{{routes.EDIT}}/{{user.userId}}{{routes.EMPLOYEE_DETAILS}}"
  >
    <mat-icon class="user-menu-icon material-icons-outlined" aria-hidden="true">person</mat-icon>Profile
  </button>
  <div class="sign-button-wrapper">
    <button class="sign-button" mat-stroked-button setColor="primaryColour" color="primary" data-cy="header-user-menu-sign-out" appPreventDoubleClick (throttledClick)="signOutEmit()">Sign out</button>
  </div>
</mat-menu>
